export default __webpack_public_path__ + "static/B0237-3284985cbc2850d634730ed3ef163334.png";